export const blockIconsHardwarePhoneAndroid = (
	<span className='material-symbols-outlined'>phone_android</span>
);
